define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess, access, full, readOnly) {

	// add view security configuration
	const teamManager = ['Team Manager'];
	const configurationEditRoles = ['Configuration Editor'];
	const configurationRoles = configurationEditRoles.concat(['Configuration Viewer']);
	const currencyAdminRoles = ['Currency Administrator'];
	const unitOfMeasureAdminRoles = ['Unit of Measure Administrator'];

	const hierarchyAdminRoles = ['Hierarchy Administrator'];
	const hierarchyEditRoles = hierarchyAdminRoles.concat(['Hierarchy Editor', 'Hierarchy Library Administrator']);
	const leafFolderAdminRoles = ['Leaf Folder Administrator'];

	const productSpecAdminRoles = ['Product Specification Administrator'];
	const ProductSpecLibAdminRoles = ["Product Specification Library Administrator"];
	const selectSetAdmin = ['Select Set Admin'];
	const allUsersGroup = ['AllUsers'];
	const projectAdmin = ['Project Administrator'];
	const projectEditor = projectAdmin.concat(["Project Editor"]);
	const proofAdmin = ['Proof Administrator'];
	const proofWorkflowEditRoles = proofAdmin.concat(['Proof Editor']);

	const documentAdminRoles = ['Document Administrator'];
	const documentEditRoles = documentAdminRoles.concat(['Document Editor'])
	const styleAdminRoles = ['Style Administrator'];
	const foodAdminRoles = ['Food Administrator'];
	const materialAdminRoles = ['Material Administrator'];
	const formulatedMaterialAdminRoles = ['Formulated Material Administrator'];
	const specificationDataSheetRoles = productSpecAdminRoles.concat(['TDS - Spec Creator', 'TDS - Spec Administrator']);
	const externalApiAdminRoles = ['External API Administrator'];

	const serviceProviderAdminRoles = ['Service Provider Administrator'];
	const serviceProviderViewRoles = ['Service Provider Viewer'];

	csiAccess.addViewRoles({
		"_CS_Data": {
			"AllProjects": {
				"NewProject": access(full(projectAdmin))
			},
			"CanvasTemplates": {
				"NewCanvasTemplate": access(full(ProductSpecLibAdminRoles)),
				"Copy": access(full(ProductSpecLibAdminRoles))
			},
			"CommentCategory": {
				"": access(readOnly(allUsersGroup))
			},
			"CommentCategorySetup": {
				"NewCommentCategorySetup": access(full(configurationEditRoles))
			},
			"Currency": {
				"NewCurrency": access(full(currencyAdminRoles))
			},
			"CurrencyTables": {
				"NewCurrencyExchangeTable": access(full(currencyAdminRoles)),
				"Copy": access(full(currencyAdminRoles))
			},
			"LookupItems": {
				"Copy": access(full(ProductSpecLibAdminRoles)),
				"NewLookupItem": access(full(ProductSpecLibAdminRoles))
			},
			"Project": {
				"StateHeader": {
					"ProjectToInProgress": access(full(projectAdmin)),
					"ProjectToComplete": access(full(projectEditor)),
					"ProjectToCanceled": access(full(projectEditor)),
					"ProjectBackToDraft": access(full(projectEditor)),
					"ProjectCompleteToInProgress": access(full(projectEditor))
				}
			},
			"POSelectSets": {
				"NewSelectSet": access(full(selectSetAdmin)),
				"Copy": access(full(selectSetAdmin))
			},
			"SelectSets": {
				"NewSelectSet": access(full(selectSetAdmin)),
				"Copy": access(full(selectSetAdmin))
			},
			"UOMConversions": {
				"NewUOMConversion": access(full(unitOfMeasureAdminRoles)),
				"Copy": access(full(unitOfMeasureAdminRoles))
			},
			"UOMTypes": {
				"NewUOMType": access(full(unitOfMeasureAdminRoles))
			},
		},
		"_CS_Site": {
			"AnnouncementManagement": {
				"": access(readOnly(teamManager), full(configurationEditRoles))
			},
			"Companies": {
				"": access(full(teamManager))
			},
			"CompanionApps": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"CompanyInfo": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"Configuration": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"CustomViewsManagement": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"Groups": {
				"": access(full(teamManager))
			},
			"HierarchySecurityGroups": {
				"SelectProductHierarchyFolders": access(full(teamManager))
			},
			"Localization": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"LocaleClasses": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"LocaleEnumerations": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"LocaleActions": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"LocaleResources": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"LocaleViews": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"LocaleViewResources": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"Roles": {
				"": access(readOnly(configurationRoles), full(teamManager))
			},
			"Search": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			},
			"Security": {
				"": access(full(teamManager))
			},
			"ServiceAccounts": {
				"": access(readOnly(configurationRoles), full(teamManager))
			},
			"UserDefaults": {
				"": access(full(configurationEditRoles), full(teamManager))
			},
			"Users": {
				"": access(readOnly(configurationRoles), full(teamManager))
			},
			"Views": {
				"": access(readOnly(configurationRoles), full(configurationEditRoles))
			}

		},
		"CrewHolder": {
			"ManagedCrew": {
				"CreateCrew": access(full(teamManager)),
				"RemoveCrew": access(full(teamManager))
			}
		},
		"Crew": {
			"AssignedAgentRoleUsers": {
				"": access(readOnly(allUsersGroup), full(teamManager))
			},
			"AssignedAgentUserRoles": {
				"": access(readOnly(allUsersGroup), full(teamManager))
			},
			"RoleUsers": {
				"": access(readOnly(allUsersGroup), full(teamManager))
			},
			"OnlineRoleUsers": {
				"": access(readOnly(allUsersGroup), full(teamManager))
			},
			"SupplierRoleUsers": {
				"": access(readOnly(allUsersGroup), full(teamManager))
			},
			"UserRoles": {
				"": access(readOnly(allUsersGroup), full(teamManager))
			},
			"OnlineUserRoles": {
				"": access(readOnly(allUsersGroup), full(teamManager))
			},
			"SupplierUserRoles": {
				"": access(readOnly(allUsersGroup), full(teamManager))
			}
		},
		"DocumentContainer": {
			"Documents": {
				"AddReferenceToStyles": access(full(documentAdminRoles)),
				"StartProof": access(full(proofAdmin)),
				"EditProofWorkflow": access(full(proofWorkflowEditRoles)),
				"CancelProof|Child:CurrentRevision": access(full(proofAdmin)),
				"ReviseProofFile": access(full(documentEditRoles)),
				"PushAsReferencedDocument": access(full(documentEditRoles))
			}
		},
		"ProductHierarchyLevel": {
			"Folders": {
				"Copy": access(full(hierarchyAdminRoles), full(leafFolderAdminRoles)),
				"Delete": access(full(hierarchyAdminRoles)),
				"Edit": access(full(hierarchyEditRoles)),
				"NewProductHierarchyFolder": access(full(hierarchyAdminRoles), full(leafFolderAdminRoles)),
			}
		},
		"Project": {
			"Items": {
				"NewFood": access(full(foodAdminRoles)),
				"NewStyle": access(full(styleAdminRoles)),
				"NewMaterial": access(full(materialAdminRoles)),
				"NewFormulatedMaterial": access(full(formulatedMaterialAdminRoles))
			},
			"SpecificationDataSheets": {
				"Copy": access(full(specificationDataSheetRoles)),
				"Delete": access(full(specificationDataSheetRoles)),
				"NewFromSpecificationDataSheet": access(full(specificationDataSheetRoles)),
				"NewFromTemplate": access(full(specificationDataSheetRoles)),
				"NewSpecificationDataSheet": access(full(specificationDataSheetRoles))
			}
		},
		"Selectable": {
			"SelectSets": {
				"NewSelectSet": access(full(selectSetAdmin)),
				"NewStyleSelectSet": access(full(selectSetAdmin)),
				"NewFromStyleSelectSet": access(full(selectSetAdmin)),
				"NewColorwaySelectSet": access(full(selectSetAdmin)),
				"NewFromColorwaySelectSet": access(full(selectSetAdmin)),
				"NewStyleSupplierItemSelectSet": access(full(selectSetAdmin)),
				"NewFromStyleSupplierItemSelectSet": access(full(selectSetAdmin)),
				"NewThemeItemSelectSet": access(full(selectSetAdmin)),
				"NewFromThemeSelectSet": access(full(selectSetAdmin)),
				"Copy": access(full(selectSetAdmin))
			}
		},
		"UOMType": {
			"UOMs": {
				"NewUnitOfMeasure": access(full(unitOfMeasureAdminRoles)),
			},
		}
	});
});
